import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Icon from '../../core/components/Icon'
import {queryTodoStatus} from '../actions'

const STATUS_ORDER = ['Timeout', 'TodoWithin12Hours', 'Todo']

function statusStyle(status) {
    if (status) {
        switch(status.value) {
            case 'Todo': return 'success'
            case 'TodoWithin12Hours': return 'warning'
            case 'Timeout': return 'danger'
        }
    }
}

function getActor(user) {
    switch(user.userType) {
        case 'patrimonyManager':
        case 'executive':
        case 'callCenterOperator':
            return user.userType.charAt(0).toUpperCase() + user.userType.slice(1)
        default:
            return null
    }
}

class TodoStatusIcon extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            exactStatus: {}
        }
    }

    componentDidMount() {
        const {dispatch, user} = this.props
        const actor = getActor(user)

        if (actor) {
            dispatch(queryTodoStatus(actor))
            this._interval = setInterval(() => {
                dispatch(queryTodoStatus(actor))
            }, 60 * 1000)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.status != this.props.status) {
            const {status} = nextProps

            const exactStatus = status.sort((a, b) => STATUS_ORDER.indexOf(a.value) - STATUS_ORDER.indexOf(b.value))[0]
            this.setState({exactStatus})
        }
    }

    componentWillUnmount() {
        clearInterval(this._interval)
    }

    render() {
        const {dispatch, status, ...others} = this.props
        const {exactStatus} = this.state

        return (
            <Icon
                count={exactStatus && exactStatus.count}
                status={statusStyle(exactStatus)}
                {...others} />
        )
    }
}

TodoStatusIcon = connect((state) => ({
    status: state.workflow.todo.status
}))(TodoStatusIcon)

export default TodoStatusIcon


// WEBPACK FOOTER //
// ./lib/workflow/components/TodoStatusIcon.js